// Nested structures keep their shape rather than being flattened into the comma-joined
// list: without this, a list of lists reads exactly like a flat list.
const formatArrayItem = (item: unknown): string => {
  if (item !== null && typeof item === 'object') return JSON.stringify(item);
  return formatOutputValue(item);
};

// Formats a code action's saved output value for the read-only sidebar. The values are
// the raw JSON the user's Python returned, so falsy-but-real values (false, 0) have to
// render as themselves instead of collapsing to an empty string.
export const formatOutputValue = (value: unknown): string => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.map(formatArrayItem).join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};
